import { el } from 'redom';

import './index.scss';

function getDefaultOpacity() {
  return 1;
}

class OpacityInput {

  constructor(configuration) {

    this.onChange = configuration.onChange;

    var opacity = configuration.opacity;

    if (opacity === void 0 || opacity === null) {
      opacity = getDefaultOpacity();
    }

    this.opacity = opacity;

    this.el = el('.opacity-input-main', [
      this.renderOpacityField()
    ]);

  }

  renderOpacityField() {

    var self = this;

    var inputAttributes = {
      type: 'number',
      min: 0,
      max: 1,
      step: 0.1,
      value: this.opacity,
      oninput: function handleOpacityInput(event) {
        var value = parseFloat(event.target.value);
        if (isNaN(value) === true) {
          value = 1;
        }
        if (value < 0) {
          value = 0;
        }
        if (value > 1) {
          value = 1;
        }
        self.opacity = value;
        self.propagateChange();
      }
    };

    this.opacityInput = el('input.opacity-number-input', inputAttributes);

    var fieldElement = el('.opacity-input-field', [
      el('label.opacity-input-label.field-label', 'Opacity'),
      this.opacityInput
    ]);

    return fieldElement;

  }

  propagateChange() {

    this.onChange(this.opacity);

  }

  update(configuration) {

    var opacity = configuration.opacity;

    if (opacity === void 0 || opacity === null) {
      opacity = getDefaultOpacity();
    }

    this.opacity = opacity;
    this.onChange = configuration.onChange;

    this.opacityInput.value = this.opacity;

  }

}

export default OpacityInput;
export { getDefaultOpacity };